import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
	setSelectedOnwardFlight,
	toggleFlightDetail,
} from '../../reducers/UiReducer';
const FlightRow = ({ item, location }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	return (
		<div>
			<Box
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					borderRadius: 4,
					background: '#fff',
					filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
					padding: '10px 30px',
					marginTop: 10,
				}}>
				<Box>
					<img
						src={`https://nitish.musafirbazar.com/static/media/${
							item.Supplier === 'TBO'
								? item.AirlineCode
								: item.Supplier === 'ETR'
								? item.Airline_Code
								: item.Supplier === 'TJK'
								? item.sI[0].fD.aI.code
								: ''
						}.gif`}
						style={{ height: 50 }}
					/>
					<br></br>
					<span
						style={{
							color: 'rgba(0,0,0,.38)',
							fontSize: 12,
						}}>
						{item.Supplier === 'TBO'
							? item.Segments[0].slice(0, 1).map((i) => {
									return i.Airline.AirlineName;
							  })
							: item.Supplier === 'ETR'
							? item.Segments[0].Airline_Name
							: item.Supplier === 'TJK'
							? item.sI[0].fD.aI.name
							: ''}
					</span>
					<br></br>
					<span
						style={{
							color: 'rgba(0,0,0,.38)',
							fontSize: 12,
						}}>
						{`${
							item.Supplier === 'TBO'
								? item.AirlineCode
								: item.Supplier === 'ETR'
								? item.Segments[0].Airline_Code
								: item.Supplier === 'TJK'
								? item.sI[0].fD.aI.code
								: ''
						}${
							item.Supplier === 'TBO'
								? item.Segments[0].slice(0, 1).map((i) => {
										return i.Airline.FlightNumber;
								  })
								: item.Supplier === 'ETR'
								? item.Segments[0].Flight_Number
								: item.Supplier === 'TJK'
								? item.sI[0].fD.fN
								: ''
						}`}
					</span>
				</Box>

				<Box>
					<span
						style={{
							fontSize: 14,
							color: 'rgba(0,0,0,.38)',
						}}>
						{item.Supplier === 'TBO'
							? item.FareRules[0].Origin
							: item.Supplier === 'ETR'
							? item.Origin
							: item.Supplier === 'TJK'
							? item.sI[0].da.code
							: ''}
					</span>
					<br></br>
					<span style={{ fontSize: 26 }}>
						{item.Supplier === 'TBO'
							? item.Segments[0].slice(0, 1).map((i) => {
									return i.Origin.DepTime.substr(11, 5);
							  })
							: item.Supplier === 'ETR'
							? item.Segments[0].Departure_DateTime.split(' ')[1]
							: item.Supplier === 'TJK'
							? item.sI[0].dt.substr(11, 5)
							: ''}
					</span>
					<br></br>
					<span
						style={{
							fontSize: 12,
							color: 'rgba(0,0,0,.38)',
						}}>
						{/* Tue, 15 Aug */}
						{`${new Date(
							item.Supplier === 'TBO'
								? item.Segments[0].slice(0, 1).map((i) => {
										return i.Origin.DepTime.split('T')[0];
								  })
								: item.Supplier === 'ETR'
								? item.Segments[0].Departure_DateTime.split(' ')[0]
								: item.Supplier === 'TJK'
								? item.sI[0].dt.split('T')[0]
								: ''
						).toLocaleString('en-us', {
							weekday: 'short',
						})} ,  ${new Date(
							item.Supplier === 'TBO'
								? item.Segments[0].slice(0, 1).map((i) => {
										return i.Origin.DepTime.split('T')[0];
								  })
								: item.Supplier === 'ETR'
								? item.Segments[0].Departure_DateTime.split(' ')[0]
								: item.Supplier === 'TJK'
								? item.sI[0].dt.split('T')[0]
								: ''
						).getDate()} ${new Date(
							item.Supplier === 'TBO'
								? item.Segments[0].slice(0, 1).map((i) => {
										return i.Origin.DepTime.split('T')[0];
								  })
								: item.Supplier === 'ETR'
								? item.Segments[0].Departure_DateTime.split(' ')[0]
								: item.Supplier === 'TJK'
								? item.sI[0].dt.split('T')[0]
								: ''
						).toLocaleString('en-us', {
							month: 'short',
						})}`}
					</span>
					<br></br>
					{/* <span
														style={{ fontSize: 12, color: 'rgba(0,0,0,.38)' }}>
														Mumbai
													</span> */}
				</Box>
				<Box textAlign={'center'}>
					<span
						style={{
							fontSize: 14,
							color: 'rgba(0,0,0,.38)',
						}}>
						2hr 15min
					</span>
					<br></br>
					<span>-------------------</span>
					<br></br>

					<span>
						{item.Supplier === 'TBO'
							? item.Segments[0].length === 1
								? 'Non Stop'
								: item.Segments[0].length === 2
								? '1 Stop'
								: item.Segments[0].length === 3
								? '2 Stop'
								: ''
							: item.Supplier === 'ETR'
							? item.Segments.length === 1
								? 'Non Stop'
								: item.Segments.length === 2
								? '1 Stop'
								: item.Segments.length === 3
								? '2 Stop'
								: ''
							: item.Supplier === 'TJK'
							? item.sI.length === 1
								? 'Non Stop'
								: item.sI.length === 2
								? '1 Stop'
								: item.sI.length === 3
								? '2 Stop'
								: ''
							: ''}
					</span>
				</Box>
				<Box>
					<span
						style={{
							fontSize: 14,
							color: 'rgba(0,0,0,.38)',
						}}>
						{item.Supplier === 'TBO'
							? item.Segments[0].length == 2
								? item.Segments[0]
										.filter((i, index) => index === 1)
										.map((it) => {
											return it.Destination.Airport.AirportCode;
										})
								: item.Segments[0].length == 3
								? item.Segments[0]
										.filter((i, index) => index === 2)
										.map((it) => {
											return it.Destination.Airport.AirportCode;
										})
								: item.Segments[0].length == 1
								? item.Segments[0].map((it) => {
										return it.Destination.Airport.AirportCode;
								  })
								: ''
							: item.Supplier === 'ETR'
							? item.Destination
							: item.Supplier === 'TJK'
							? item.sI.length === 1
								? item.sI
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.aa.cityCode;
										})
								: item.sI.length === 2
								? item.sI
										.filter((i, index) => index === 1)
										.map((it) => {
											return it.aa.cityCode;
										})
								: item.sI.length === 3
								? item.sI
										.filter((i, index) => index === 2)
										.map((it) => {
											return it.aa.cityCode;
										})
								: ''
							: ''}
					</span>
					<br></br>
					<span style={{ fontSize: 26 }}>
						{item.AirlineCode
							? item.Segments[0].length == 3
								? item.Segments[0]
										.filter((i, index) => index === 2)
										.map((i) => {
											return i.Destination.ArrTime.substr(11, 5);
										})
								: item.Segments[0].length == 2
								? item.Segments[0]
										.filter((i, index) => index === 1)
										.map((i) => {
											return i.Destination.ArrTime.substr(11, 5);
										})
								: item.Segments[0].length == 1
								? item.Segments[0]
										.filter((i, index) => index === 0)
										.map((i) => {
											return i.Destination.ArrTime.substr(11, 5);
										})
								: ''
							: item.Supplier === 'ETR'
							? item.Segments.length === 1
								? item.Segments.filter((i, index) => index === 0).map((it) => {
										return it.Arrival_DateTime.substr(11, 5);
								  })
								: item.Segments.length === 2
								? item.Segments.filter((i, index) => index === 1).map((it) => {
										return it.Arrival_DateTime.substr(11, 5);
								  })
								: item.Segments.length === 3
								? item.Segments.filter((i, index) => index === 2).map((it) => {
										return it.Arrival_DateTime.substr(11, 5);
								  })
								: ''
							: item.Supplier === 'TJK'
							? item.sI.length === 1
								? item.sI
										.filter((i, index) => index === 0)
										.map((it) => {
											return it.at.substr(11, 5);
										})
								: item.sI.length === 2
								? item.sI
										.filter((i, index) => index === 1)
										.map((it) => {
											return it.at.substr(11, 5);
										})
								: item.sI.length === 3
								? item.sI
										.filter((i, index) => index === 2)
										.map((it) => {
											return it.at.substr(11, 5);
										})
								: ''
							: ''}{' '}
					</span>
					<br></br>
					<span
						style={{
							fontSize: 12,
							color: 'rgba(0,0,0,.38)',
						}}>
						{`${new Date(
							item.AirlineCode
								? item.Segments[0].length == 3
									? item.Segments[0]
											.filter((i, index) => index === 2)
											.map((i) => {
												return i.Destination.ArrTime.split('T')[0];
											})
									: item.Segments[0].length == 2
									? item.Segments[0]
											.filter((i, index) => index === 1)
											.map((i) => {
												return i.Destination.ArrTime.split('T')[0];
											})
									: item.Segments[0].length == 1
									? item.Segments[0]
											.filter((i, index) => index === 0)
											.map((i) => {
												return i.Destination.ArrTime.split('T')[0];
											})
									: ''
								: item.Supplier === 'ETR'
								? item.Segments.length === 1
									? item.Segments.filter((i, index) => index === 0).map(
											(it) => {
												return it.Arrival_DateTime.split(' ')[0];
											}
									  )
									: item.Segments.length === 2
									? item.Segments.filter((i, index) => index === 1).map(
											(it) => {
												return it.Arrival_DateTime.split(' ')[0];
											}
									  )
									: item.Segments.length === 3
									? item.Segments.filter((i, index) => index === 2).map(
											(it) => {
												return it.Arrival_DateTime.split(' ')[0];
											}
									  )
									: ''
								: item.Supplier === 'TJK'
								? item.sI.length === 1
									? item.sI
											.filter((i, index) => index === 0)
											.map((it) => {
												return it.at.split('T')[0];
											})
									: item.sI.length === 2
									? item.sI
											.filter((i, index) => index === 1)
											.map((it) => {
												return it.at.split('T')[0];
											})
									: item.sI.length === 3
									? item.sI
											.filter((i, index) => index === 2)
											.map((it) => {
												return it.at.split('T')[0];
											})
									: ''
								: ''
						).toLocaleString('en-us', {
							weekday: 'short',
						})} ,  ${new Date(
							item.AirlineCode
								? item.Segments[0].length == 3
									? item.Segments[0]
											.filter((i, index) => index === 2)
											.map((i) => {
												return i.Destination.ArrTime.split('T')[0];
											})
									: item.Segments[0].length == 2
									? item.Segments[0]
											.filter((i, index) => index === 1)
											.map((i) => {
												return i.Destination.ArrTime.split('T')[0];
											})
									: item.Segments[0].length == 1
									? item.Segments[0]
											.filter((i, index) => index === 0)
											.map((i) => {
												return i.Destination.ArrTime.split('T')[0];
											})
									: ''
								: item.Supplier === 'ETR'
								? item.Segments.length === 1
									? item.Segments.filter((i, index) => index === 0).map(
											(it) => {
												return it.Arrival_DateTime.split(' ')[0];
											}
									  )
									: item.Segments.length === 2
									? item.Segments.filter((i, index) => index === 1).map(
											(it) => {
												return it.Arrival_DateTime.split(' ')[0];
											}
									  )
									: item.Segments.length === 3
									? item.Segments.filter((i, index) => index === 2).map(
											(it) => {
												return it.Arrival_DateTime.split(' ')[0];
											}
									  )
									: ''
								: item.Supplier === 'TJK'
								? item.sI.length === 1
									? item.sI
											.filter((i, index) => index === 0)
											.map((it) => {
												return it.at.split('T')[0];
											})
									: item.sI.length === 2
									? item.sI
											.filter((i, index) => index === 1)
											.map((it) => {
												return it.at.split('T')[0];
											})
									: item.sI.length === 3
									? item.sI
											.filter((i, index) => index === 2)
											.map((it) => {
												return it.at.split('T')[0];
											})
									: ''
								: ''
						).getDate()} ${new Date(
							item.AirlineCode
								? item.Segments[0].length == 3
									? item.Segments[0]
											.filter((i, index) => index === 2)
											.map((i) => {
												return i.Destination.ArrTime.split('T')[0];
											})
									: item.Segments[0].length == 2
									? item.Segments[0]
											.filter((i, index) => index === 1)
											.map((i) => {
												return i.Destination.ArrTime.split('T')[0];
											})
									: item.Segments[0].length == 1
									? item.Segments[0]
											.filter((i, index) => index === 0)
											.map((i) => {
												return i.Destination.ArrTime.split('T')[0];
											})
									: ''
								: item.Supplier === 'ETR'
								? item.Segments.length === 1
									? item.Segments.filter((i, index) => index === 0).map(
											(it) => {
												return it.Arrival_DateTime.split(' ')[0];
											}
									  )
									: item.Segments.length === 2
									? item.Segments.filter((i, index) => index === 1).map(
											(it) => {
												return it.Arrival_DateTime.split(' ')[0];
											}
									  )
									: item.Segments.length === 3
									? item.Segments.filter((i, index) => index === 2).map(
											(it) => {
												return it.Arrival_DateTime.split(' ')[0];
											}
									  )
									: ''
								: item.Supplier === 'TJK'
								? item.sI.length === 1
									? item.sI
											.filter((i, index) => index === 0)
											.map((it) => {
												return it.at.split('T')[0];
											})
									: item.sI.length === 2
									? item.sI
											.filter((i, index) => index === 1)
											.map((it) => {
												return it.at.split('T')[0];
											})
									: item.sI.length === 3
									? item.sI
											.filter((i, index) => index === 2)
											.map((it) => {
												return it.at.split('T')[0];
											})
									: ''
								: ''
						).toLocaleString('en-us', {
							month: 'short',
						})}`}
					</span>
					<br></br>
					{/* <span
														style={{ fontSize: 12, color: 'rgba(0,0,0,.38)' }}>
														Mumbai
													</span> */}
				</Box>
				<h2>
					₹
					{item.Supplier === 'TBO'
						? Number(
								Math.round(
									Number(
										Number(Math.round(item.Fare.Total_Amount)) -
											Number(Math.round(item.Fare.MFB_Discount))
									)
								)
						  )
						: item.Supplier === 'ETR'
						? Number(
								Math.round(Number(Number(Math.round(item.Fares.Total_Amount))))
						  )
						: item.Supplier === 'TJK'
						? Number(
								Math.round(
									Number(
										Number(Math.round(item.totalPriceList.fd.Total_Amount))
									)
								)
						  )
						: ''}
				</h2>
				<Box>
					<Button
						onClick={() =>
							navigate('/flightbooking', {
								state: {
									onward: item,
									formData: location.state,
								},
							})
						}
						style={{
							background: '#EC5B24',
							color: 'white',
							width: '100%',
						}}>
						Book
					</Button>
					<p
						style={{ marginTop: 20, fontSize: 12, cursor: 'pointer' }}
						onClick={() => {
							dispatch(toggleFlightDetail(true));
							dispatch(setSelectedOnwardFlight(item));
						}}>
						Flight Details
					</p>
				</Box>
			</Box>
		</div>
	);
};

export default FlightRow;
